import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ExerciseScores,
  SeriesScores,
  StudentSeriesScores,
} from '../../../../../config/api/models/Score';
import { TooltipTitleText, Icons, SvgIcon } from '../../../../shared/components';
import { Theme, styled} from '@material-ui/core';

type Props = {
  data: Record<string, StudentSeriesScores>;
  seriesId: string;
  exerciseId: string;
};

const StudentName = styled('td')<Theme>(({ theme }) => ({
  padding: theme.spacing(0, 4, 0, 0),
}));

const StudentData = styled('td')<Theme>(({ theme }) => ({
  padding: theme.spacing(0, 1),
  textAlign: 'right',
}));

const getScoresForExercise = (
  scores: Record<string, SeriesScores>,
  seriesId: string,
  exerciseId: string
): string => {
  const seriesScores: Record<string, ExerciseScores> = scores[seriesId];
  if (!seriesScores) return '';

  const exerciseScore: ExerciseScores = scores[seriesId][exerciseId];
  if (!exerciseScore || exerciseScore.maxScore === 0) return '';

  return `${Math.round((exerciseScore.score / exerciseScore.maxScore) * 100)}%`;
};

const TeacherExerciseTooltip: FC<Props> = ({ data, seriesId, exerciseId }) => {
  const { t } = useTranslation();

  return (
    <table>
      <thead>
        <tr>
          <StudentName>
            <TooltipTitleText>{t('progressAndScores.series.student')}</TooltipTitleText>
          </StudentName>
          <StudentData>
            <SvgIcon icon={Icons.SCORES} />
          </StudentData>
        </tr>
      </thead>
      <tbody>
        {Object.keys(data).map((key: string) => {
          const score: string = getScoresForExercise(data[key].scores, seriesId, exerciseId);
          return score === '' ? null : (
            <tr key={key}>
              <StudentName>{`${data[key].student.name} ${data[key].student.surname}`}</StudentName>
              <StudentData>{score}</StudentData>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TeacherExerciseTooltip;
